import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import StringUtils from '../../../../utils/string';
import { addQueryParam } from '../../../../utils/url';
import { useHeaderNavigationButtonsIsDarkTheme } from '../../utils';
import { useControlFocusType } from '../../../../hooks/useControlFocusType';
import { AngleLeftSmall } from '../../../../components/Icons/AngleLeftSmall';
import { AngleRightSmall } from '../../../../components/Icons/AngleRightSmall';
import { useGetUrlTabParam } from '../../../../components/Tabs/hooks/useGetUrlTabParam';
import { addTabQueryParam } from '../../../../components/Tabs/utils';
import RouteLink from '../../../../components/RouteLink';

export const NavigationRouteButtons = memo(function NavigationRouteButtons({ nextPageUrl, prevPageUrl, useSession }) {
	const { handleElementClick, handleElementFocus, handleElementBlur } = useControlFocusType();

	const tabId = useGetUrlTabParam();

	const isDarkTheme = useHeaderNavigationButtonsIsDarkTheme();
	const nextNavigationButtonClasses = classNames(classes.navigationButton, {
		[classes.navigationButton_inactive]: StringUtils.isNullOrEmpty(nextPageUrl),
	});

	const prevNavigationButtonClasses = classNames(classes.navigationButton, {
		[classes.navigationButton_inactive]: StringUtils.isNullOrEmpty(prevPageUrl),
	});

	const formattedPrevPageUrl = useSession ? addQueryParam(prevPageUrl, 'session', true) : prevPageUrl;

	const formattedNextPageUrl = useSession ? addQueryParam(nextPageUrl, 'session', true) : nextPageUrl;

	const preserveActiveTabId = (url) => {
		return addTabQueryParam(url, tabId);
	};

	return (
		<div className={classes.navigationButtons}>
			<RouteLink
				className={prevNavigationButtonClasses}
				icon={<AngleLeftSmall />}
				link={!isDarkTheme}
				linkDark={isDarkTheme}
				rounded
				styledButton
				href={preserveActiveTabId(formattedPrevPageUrl)}
				disabled={StringUtils.isNullOrEmpty(prevPageUrl)}
				dataTestId='previousPageButton'
				onFocus={handleElementFocus}
				onBlur={handleElementBlur}
				onClick={handleElementClick}
				useDirty
			/>
			<RouteLink
				className={nextNavigationButtonClasses}
				icon={<AngleRightSmall />}
				link={!isDarkTheme}
				linkDark={isDarkTheme}
				rounded
				styledButton
				href={preserveActiveTabId(formattedNextPageUrl)}
				disabled={StringUtils.isNullOrEmpty(nextPageUrl)}
				dataTestId='nextPageButton'
				onFocus={handleElementFocus}
				onBlur={handleElementBlur}
				onClick={handleElementClick}
				useDirty
			/>
		</div>
	);
});

NavigationRouteButtons.propTypes = {
	nextPageUrl: PropTypes.string,
	prevPageUrl: PropTypes.string,
	useSession: PropTypes.bool,
};

NavigationRouteButtons.defaultProps = {
	useSession: true,
};
